import request from '@/utils/request'

// 查询码上办ccc列表
export function listCccmbOld(query) {
  return request({
    url: '/web/msb/cccmbOld/list',
    method: 'get',
    params: query
  })
}
